import _slicedToArray from "/builds/M9cfiv79/0/everlywell/apps/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useState } from "react";
import { useSpring, useSprings, config } from "react-spring";
import TabItem from "./TabItem";
import * as S from "./styles";
export var TabMenu = function TabMenu(_ref) {
  var e = _ref.ariaLabel,
      t = _ref.ariaControls,
      _ref$initialActiveInd = _ref.initialActiveIndex,
      a = _ref$initialActiveInd === void 0 ? 0 : _ref$initialActiveInd,
      i = _ref.children,
      s = _ref.className,
      r = _ref.id,
      n = _ref.onItemSelect;

  var _useState = useState(a),
      _useState2 = _slicedToArray(_useState, 2),
      o = _useState2[0],
      c = _useState2[1],
      _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      l = _useState4[0],
      f = _useState4[1],
      _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      d = _useState6[0],
      m = _useState6[1];

  useEffect(function () {
    var e = document.querySelector("[data-index=\"".concat(a, "\"]"));
    e && (m(e.offsetWidth), f(e.offsetLeft));
  }, [i]);

  var _useSpring = useSpring(function () {
    return {
      width: d,
      transform: "translateX(".concat(l, "px)"),
      config: Object.assign(Object.assign({}, config.stiff), {
        friction: 32,
        tension: 200
      })
    };
  }, [d, l, o]),
      _useSpring2 = _slicedToArray(_useSpring, 1),
      p = _useSpring2[0],
      u = React.Children.toArray(i),
      _useSprings = useSprings(React.Children.count(i), function () {
    return {
      opacity: 1
    };
  }),
      _useSprings2 = _slicedToArray(_useSprings, 2),
      b = _useSprings2[0],
      y = _useSprings2[1],
      g = function g() {
    y.start(function () {
      return {
        opacity: 1
      };
    });
  },
      h = function h(e) {
    y.start(function (t) {
      return e !== t ? {
        opacity: .5
      } : {
        opacity: 1
      };
    });
  },
      E = function E(e, t) {
    t && (f(t.offsetLeft), m(t.offsetWidth), c(e), n(e)), g();
  };

  return React.createElement(S.TabMenuWrapper, {
    className: s,
    id: r,
    "data-testid": r
  }, React.createElement(S.Tabs, {
    "data-testid": "tab-menu-tabs",
    role: "tablist",
    "aria-label": e
  }, b.map(function (_ref2, a) {
    var e = _ref2.opacity;
    return React.createElement(TabItem, {
      ariaControls: t,
      handleClick: E,
      handleMouseEnter: h,
      handleMouseLeave: g,
      tabIndex: a,
      key: a,
      opacity: e
    }, u[a]);
  })), React.createElement(S.AnimatedActiveIndicator, {
    style: p
  }));
};
export default TabMenu;